<div class="communication-alert-overlay" role="dialog" aria-modal="true"
  [attr.aria-label]="dialogAriaLabelKey() | translate"
  [attr.aria-labelledby]="titleId()">
  <article class="communication-alert-dialog"
    [class.alert-information]="alert().level === CommunicationLevel.Information"
    [class.alert-medium]="alert().level === CommunicationLevel.ModerateAlert"
    [class.alert-high]="alert().level === CommunicationLevel.StrongAlert">
    <header class="communication-alert-dialog__header">
      <div class="communication-alert-dialog__heading">
        <span class="communication-alert-dialog__eyebrow">{{ levelLabelKey(alert().level) | translate }}</span>
        <h2 [id]="titleId()">{{ alert().title }}</h2>
      </div>
      <button type="button" class="communication-alert-close"
        [attr.aria-label]="'communications.action.close' | translate"
        (click)="close()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </header>
    <div class="communication-alert-tags">
      <span class="communication-alert-tag communication-alert-tag--level">
        {{ levelShortLabelKey(alert().level) | translate }}
      </span>
      <span class="communication-alert-tag">{{ alert().theme }}</span>
      <span class="communication-alert-tag">{{ alert().publishingTeam }}</span>
      <time class="communication-alert-date" [attr.datetime]="alert().publicationUtc">
        <fa-icon [icon]="faClock" aria-hidden="true"></fa-icon>
        {{ formatParisDate(alert().publicationUtc) }}
      </time>
    </div>
    <div class="communication-alert-dialog__content">{{ alert().content }}</div>
    <ng-casto-communication-media-gallery [attachments]="alert().attachments"></ng-casto-communication-media-gallery>
    <footer class="communication-alert-dialog__footer">
      @if (canNavigate()) {
        <nav class="communication-alert-dialog__navigation"
          [attr.aria-label]="'communications.header.alertNavigation' | translate">
          <button type="button" class="communication-alert-dialog__nav-button"
            (click)="previousRequested.emit()">
            {{ 'communications.action.previousAlert' | translate }}
          </button>
          <span class="communication-alert-dialog__position">
            {{ 'communications.header.alertPosition' | translate: { current: currentPosition(), total: totalAlerts() } }}
          </span>
          <button type="button" class="communication-alert-dialog__nav-button"
            (click)="nextRequested.emit()">
            {{ 'communications.action.nextAlert' | translate }}
          </button>
        </nav>
      }
      <ng-casto-button class="primary"
        [label]="'communications.action.acknowledge' | translate"
        [disabled]="preview()"
        [attr.aria-disabled]="preview()"
        [attr.tabindex]="preview() ? -1 : null"
        (click)="acknowledge()"></ng-casto-button>
    </footer>
  </article>
</div>
